

























































































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Navigation extends Vue {
  showDropdown = false

  get isDocs () {
    return this.$route.path.substring(0, 5) === '/docs'
  }

  hideDropdown (evt: MouseEvent) {
    evt.preventDefault()

    this.showDropdown = false
  }

  toggleDropdown (evt: MouseEvent) {
    evt.preventDefault()

    this.showDropdown = !this.showDropdown
  }

  toggleMobileNav () {
    const list = document.getElementById('mobile-nav-list')

    if (!list) {
      return
    }

    list.classList.toggle('showNav')
  }
}
